import React from 'react';
import { LOCKED_TEAM_MEMBERS_IMAGE } from '../mockImages';

const LockedTeamMembersSection = () => (
    <div aria-hidden="true">
        <img
            src={LOCKED_TEAM_MEMBERS_IMAGE}
            alt="Locked team members preview"
            style={{
                display: 'block',
                width: '100%',
                height: 'auto'
            }}
        />
    </div>
);

export default LockedTeamMembersSection;
